<template>
  <div v-if="sideMenu">
    <div
      class="side-menu hidden md:flex flex-col z-50"
      :class="mainImage ? 'sm-image' : 'sm-no-image bg-gray-100 bg-opacity-30 border-r' "
      :style="mainImage ?`background: url(/${mainImage}) center no-repeat`:``"
    >
      <div 
        class="flex-1 flex flex-col overflow-y-auto side-menu-in"
        :class="mainImage?`bg-black bg-opacity-60`:``"
      >
        <nav
          class="flex-1 side-nav"
          aria-label="Sidebar"
        >
          <div
            :class="mainImage?`dark-side`:`light-side`"
            class="nlink-a flex aic text-sm font-medium relative"
          >
            <div 
                class="flex aic w-full px-9 sub-head space-x-4"
                :class="mainImage ? 'img-sub-head' : 'bg-secondary-light' "
              >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M4 22h-4v-4h4v4zm0-12h-4v4h4v-4zm0-8h-4v4h4v-4zm3 0v4h17v-4h-17zm0 12h17v-4h-17v4zm0 8h17v-4h-17v4z"/>
              </svg>
              <span class="nunito-medium">{{$t("Menu")}}</span>
            </div>
          </div>
          <!-- <h2 class="flex aic jcb py-4 px-10 bg-gray-100 bg-opacity-10 text-secondary fs-20">
            {{$t('Menu')}}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="white"
            >
              <path
                fill-rule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </h2> -->
          <div :class="mainImage?`dark-side`:`light-side`">
              <button
                v-wave
                class="nsn-a flex aic px-9 py-4 text-sm relative cursor-pointer w-full"
                :class="{ 'active ': selectedCategory == category }"
                @click="selectCategory(category)"
                v-for="category in categories"
                :key="category.id"
                :aria-label="category.name"
              >
                <div class="flex aic w-full z-hard relative text-left">
                  <div class="side-icon">
                    <img
                      :src="
                        category.image ? storageUrl + category.image : '/dish.webp'
                      "
                      :alt="category.name"
                      class="w-30p h-30p object-cover mr-4"
                    />
                  </div>
                  {{ category.name }}
                </div>
              </button>
            </div> 
        </nav>
        <router-link
          to="/blogs"
          :class="mainImage?`dark-side`:`light-side`"
          class="nsn-a flex aic px-9 py-4 text-sm font-medium relative"
          v-if="restaurantInfo.has_blog"
        >
          <div class="flex aic w-full z-hard">
            <img
              src="/img/icon-blog.png"
              alt="Blog"
              class="w-25p mr-4"
            />
            {{$t("Blog")}}
          </div>
        </router-link>
        <button
          v-wave
          @click="showContactModal = true"
          type="button"
          :class="mainImage?`dark-side`:`light-side`"
          class="nsn-a flex aic px-9 py-4 text-sm relative"
          aria-label="About"
        >
          <div class="flex aic w-full z-hard">
            <img
              src="/img/contact.png"
              alt="logo"
              class="w-25p mr-5"
            />
            {{$t('Contact')}}
          </div>
        </button>
        <button
          v-wave
          @click="showAboutModal = true"
          type="button"
          :class="mainImage?`dark-side`:`light-side`"
          class="nsn-a flex aic px-9 py-4 text-sm relative"
          aria-label="About"
        >
          <div class="flex aic w-full z-hard">
            <img
              src="/img/about.png"
              alt="logo"
              class="w-25p mr-4 rounded-lg"
            />
            {{$t("About restaurant")}}
          </div>
        </button>
      </div>

    </div>
    <About
      :showAboutModal="showAboutModal"
      @close="showAboutModal = false"
    ></About>
    <Contact
      :showContactModal="showContactModal"
      @close="showContactModal = false"
    ></Contact>

  </div>
</template>
<script>
import About from "./About.vue";
import Contact from "./Contact.vue";

export default {
  props: ['showMenu'],
  components: { About, Contact },
  data() {
    return {
      showAboutModal: false,
      showContactModal: false,
    };
  },
  computed: {
    sideMenu(){
      if(process.env.VUE_APP_SIDEMENU == 'side_menu') {
        return true
      }
      else {
        return false
      }
    },
    logo() {
      return process.env.VUE_APP_LOGO;
    },
    mainImage() {
      if (process.env.VUE_APP_MAIN_IMAGE == 'mainImage5.png') {
        return false
      }
      else return process.env.VUE_APP_MAIN_IMAGE
    },
    
    storageUrl() {
      return process.env.VUE_APP_STORAGE_URL;
    },
    categories() {
      if (this.$store.state.orderiomApiPackage.product.categories.length) {
        const priorityList =
          this.$store.state.orderiomApiPackage.product.categories.map(
            (m) => m.pivot.priority
          );
        if (priorityList.every((item) => item != null)) {
          const categories = [
            ...this.$store.state.orderiomApiPackage.product.categories,
          ].sort((a, b) => (a.pivot.priority > b.pivot.priority ? 1 : -1));
          return categories;
        } else return this.$store.state.orderiomApiPackage.product.categories;
      } else return this.$store.state.orderiomApiPackage.product.categories;
    },
    selectedCategory() {
      return this.$store.state.orderiomApiPackage.product.selectedCategory;
    },
    restaurantId() {
      return process.env.VUE_APP_RESTAURANT_ID;
    },
    restaurantInfo() {
      return this.$store.state.orderiomApiPackage.restaurant.restaurantInfo;
    },
  },
  methods: {
    selectCategory(category) {
      this.$store.commit("product/setSelectedCategory", category);
      this.$store.dispatch("product/getProducts", {
        category: category,
        restaurantId: this.restaurantId,
      });
      this.$store.dispatch("product/getAttributeItems", {
        category: category,
        restaurantId: this.restaurantId,
      });
    },
  },
};
</script>
